import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import SeoLocalIA from "@/pages/servicios/SeoLocalIA";


export const Route = createFileRoute("/servicios/seo-local-ia")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "SEO local y Google Maps para negocios | SEOEVOLUTION" },
      { name: "description", content: "Optimización de Google Business Profile, web y señales locales para tu área de servicio. Diagnóstico personalizado, disponibilidad a consultar y mínimo de 3 meses." },
      { name: "keywords", content: "SEO local con IA, posicionamiento Google Maps, aparecer en Google Maps, SEO local para negocios, cómo aparecer en búsquedas locales, agencia SEO local España, posicionamiento local inteligente, Google Business Profile optimización, zona exclusiva SEO local" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/seo-local-ia" },
      { property: "og:title", content: "SEO local y Google Maps para negocios | SEOEVOLUTION" },
      { property: "og:description", content: "Optimización de Google Business Profile, web y señales locales para tu área de servicio. Diagnóstico personalizado, disponibilidad a consultar y mínimo de 3 meses." },
      { name: "twitter:title", content: "SEO local y Google Maps para negocios | SEOEVOLUTION" },
      { name: "twitter:description", content: "Optimización de Google Business Profile, web y señales locales para tu área de servicio. Diagnóstico personalizado, disponibilidad a consultar y mínimo de 3 meses." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/seo-local-ia" }],
    scripts: serviceSchemaScripts("seo-local-ia"),
  }),
  component: SeoLocalIA,
});
